import React from "react";
import { cn } from "../../lib/utils";

type LivePreviewSkeletonProps = {
  className?: string;
};

export const LivePreviewSkeleton: React.FC<LivePreviewSkeletonProps> = ({
  className,
}) => (
  <div
    className={cn(
      "absolute inset-0 z-10 flex flex-col gap-4 bg-card p-5 sm:p-6 overflow-hidden",
      className,
    )}
    aria-busy="true"
    aria-label="Loading site preview"
  >
    <div className="h-9 w-full max-w-lg rounded-md bg-muted animate-pulse" />
    <div className="h-6 w-2/3 max-w-md rounded-md bg-muted/90 animate-pulse" />
    <div className="mt-2 flex flex-wrap gap-3">
      <div className="h-11 w-40 rounded-lg bg-muted animate-pulse" />
      <div className="h-11 w-36 rounded-lg bg-muted/80 animate-pulse" />
    </div>
    <div className="mt-auto flex flex-wrap gap-8 pb-2">
      <div className="h-4 w-32 rounded bg-muted/90 animate-pulse" />
      <div className="h-4 w-40 rounded bg-muted/90 animate-pulse" />
    </div>
    <div
      className="pointer-events-none absolute inset-0 overflow-hidden"
      aria-hidden
    >
      <div
        className={cn(
          "absolute inset-y-0 -left-1/2 w-1/2 bg-linear-to-r from-transparent via-foreground/6 to-transparent",
          "animate-[livePreviewShimmer_1.35s_ease-in-out_infinite]",
        )}
      />
    </div>
  </div>
);
